import _ from 'lodash';

/**
 * Collection Provider Convenience API for retrieving entity pending and error states.
 * Uses provider vs. morearty binding
 */
export default class CollectionState {
  constructor(provider) {
    if (!provider) {
      throw new Error('provider must be provided!');
    }

    _.bindAll(this, ['getErrors', 'isResponsePending', 'isSavePending']);
    this.provider = provider;
  }

  getErrors(id) {
    return id ? this.provider.getErrors(id) : this.provider.getErrorsForNew();
  }

  isResponsePending(id) {
    return id ? this.provider.isPending(id) : this.provider.isPendingNew();
  }

  isSavePending(id) {
    return this.isResponsePending(id) || !_.isEmpty(this.getErrors(id));
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/collection_state.js